import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { selectActionSheet } from '@selectors'

import { ActionSheet, Paragraph, Title } from '@omnilert/components'

import { HIDE_ACTION_SHEET } from '@redux/actions/types'

import {
  BUTTON_CONTINUE,
  BUTTON_OPEN_APP,
  SAFEWALK_INSTALL_BANNER_BODY,
  SAFEWALK_INSTALL_BANNER_HEADER
} from '@assets/i18n/strings'

import i18n from 'i18n-js'

import * as localForage from 'localforage'

import { isAndroid } from 'react-device-detect'

import useStyles from './install-banner.style'


const InstallBanner = (props) => {
  const classes = useStyles(props)

  const dispatch = useDispatch()

  const actionSheet = useSelector(selectActionSheet)
  const isVisible = actionSheet === 'INSTALL'

  const handleOnCloseActionSheet = async () => {
    await localForage.setItem('installBanner', { dateCreated: Date.now() })

    dispatch({ type: HIDE_ACTION_SHEET })
  }

  const handleAppLink = () => {
    const appLink = isAndroid ? 'https://play.google.com/store/apps/details?id=com.omnilert.omnilert' : 'https://apps.apple.com/us/app/omnilert/id1472552124?itsct=apps_box_badge&amp;itscg=30200'
    window.open(appLink, '_blank')
  }

  return (
    <ActionSheet
      className={classes.actionSheet}
      onClose={() => handleOnCloseActionSheet}
      show={isVisible}
    >
      <div className={classes.info}>
        <Title
          className={classes.title}
          color='var(--card--text__color)'
          size='sm'
        >
          {i18n.t(SAFEWALK_INSTALL_BANNER_HEADER)}
        </Title>
        <Paragraph
          className={classes.body}
          color='var(--card--text__color)'
          size='md'
        >
          {i18n.t(SAFEWALK_INSTALL_BANNER_BODY)}
        </Paragraph>
        <div className={classes.buttonContainer}>
          <button
            className={classes.button}
            onClick={handleOnCloseActionSheet}
          >
            {i18n.t(BUTTON_CONTINUE)}
          </button>
          <button
            className={classes.button}
            onClick={handleAppLink}
          >
            {i18n.t(BUTTON_OPEN_APP)}
          </button>
        </div>
      </div>
    </ActionSheet>
  )
}

export default InstallBanner
